export function getSafeSupportAppArea(pathname = '') {
  const segments = pathname.split('/').filter(Boolean);

  if (segments[0] !== 'app') {
    return null;
  }

  // Only retain the top-level app area. Dynamic resource, assignment,
  // session, sample, and other record identifiers are deliberately omitted.
  return segments[1] ? `/app/${segments[1]}` : '/app';
}
